import { selectorFamily } from 'recoil';
import {
  endpointEnum,
  makeAPIRequest,
} from '../../services/rest/makeAPIRequest';
import { user } from '../atoms/user';
import { refetchToggle } from './makePHPRequest';

export const getBlockedNumbers = selectorFamily({
  key: 'getBlockedNumbers',
  get: ({ page, pageSize, sortModel, search }) =>
    //   { page, pageSize, sortModel, search = '', agentId = null }
    async ({ get }) => {
      get(refetchToggle('getBlockedNumbers'));
      try {
        const userAtom = get(user);
        // do not continue if user atom not populated
        if (!userAtom.businessid || !userAtom.apikey) {
          return {};
        }
        // const data = JSON.stringify({
        //   businessid: storageUser.businessid,
        //   apikey: storageUser.apikey,
        //   outboundsms: true,
        //   inboundsms: true,
        //   inboundcalls: true,
        //   outboundcalls: true,
        // });
        // https://api2.kixiestg.com/app/blockedNumbers/blockedNumbers/a?businessid=995&apikey=d8810712-df40-11e4-9ccc-22000ac88c3a
        // const config = {
        //   method: 'get',
        //   url: `${process.env.VITE_APP_API_DOMAIN}/${process.env.VITE_APP_API_STAGE}/blockedNumbers/numbers?businessid=${userAtom.businessid}&apikey=${userAtom.apikey}`,
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        //   // params: data,
        // };
        // const response = await axios(config);
        if (!sortModel.length) {
          sortModel = [
            {
              field: 'created',
              sort: 'desc',
            },
          ];
        }

        const response = get(
          makeAPIRequest({
            endpoint: `${endpointEnum.GET_BLOCKED_NUMBERS}?businessid=${
              userAtom.businessid
            }&apikey=${userAtom.apikey}&start=${
              (page - 1) * pageSize
            }&length=${pageSize}&sortBy=${sortModel[0].field}&sortOrder=${
              sortModel[0].sort
            }${search ? `&search=${search}` : ''}`,
            method: 'GET',
            refetchParam: 'getBlockedNumbers',
          })
        );

        // console.log(
        //   response,
        //   'response in new selector family for blocked #####'
        // );
        return response;
      } catch (error) {
        throw error;
      }
    },
});
